import React from 'react';

const StatusBadge = ({ health }) => {
  let colorClass = '';
  let text = '';

  if (health >= 80) {
    colorClass = 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20';
    text = 'Healthy';
  } else if (health >= 50) {
    colorClass = 'bg-amber-500/10 text-amber-400 border border-amber-500/20';
    text = 'Warning';
  } else {
    colorClass = 'bg-rose-500/10 text-rose-400 border border-rose-500/20';
    text = 'At Risk';
  }

  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium tracking-wide ${colorClass}`}>
      {text}
    </span>
  );
};

export default StatusBadge;